import React from 'react';

import Modal from '../../../../components/Modal';
import Tag from '../../../../components/tag/Tag/Tag';

const SubCategoryTagModal = (props) => {
  const { isOpen, setIsOpen, subCategoryList } = props;

  return (
    <Modal
      title="2차 카테고리 보기"
      wrapClassName="sub-category-tag-modal-wrapper"
      isOpen={isOpen}
      width={350}
      height={350}
      onOk={() => setIsOpen(false)}
      onClose={() => setIsOpen(false)}
    >
      {subCategoryList?.map((category) => (
        <Tag key={category.id} text={category.name} isAddHash={false} />
      ))}
    </Modal>
  );
};

export default SubCategoryTagModal;
